<template>
    <v-card elevation="0" style="background-color: white; border-radius: 25px" class="pa-6 mt-4">
        <v-row>
            <v-col cols="11" class="ma-auto">
                <v-card-title class="ma-0 pa-0">
                    <h5 class="pl-4">
                        Documents générés automatiquement ou par OD rattachées au contrôle (à ne pas
                        modifier, ni supprimer)
                    </h5>
                </v-card-title>
            </v-col>

            <!-- <v-spacer></v-spacer> -->

            <v-col cols="1" class="d-flex align-center px-0 justify-center">
                <v-row>
                    <v-col cols="6" />
                    <v-col cols="6" class="align-center pa-0">
                        <v-btn-icon
                            :icon="resultsExpand ? '$fa-chevron-up' : '$fa-chevron-down'"
                            data-cy="AuditConnectedAcrResults-documentsAutomatiques"
                            @click="resultsExpand = !resultsExpand"
                            style="width: 40px"
                            class="d-inline px-2"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-card-text v-if="resultsExpand" transition="expand">
            <v-row class="pt-6">
                <v-col class="py-0">
                    <v-data-table
                        :headers="headers"
                        :items="results"
                        class="table mt-3"
                        fixed-header
                        :items-per-page="-1"
                    >
                        <template v-slot:item="props">
                            <tr @click.stop="openDocument(props.item.id)" style="cursor: pointer">
                                <td>
                                    <!-- // ** sort don't work properly : calculated on -->
                                    <!-- // ** "name", sometimes empty -->
                                    <!-- // ** "type" is different from $t("document.shortType." + props.item.type -->

                                    <!-- // ** Date -->
                                    <h3
                                        v-if="
                                            props.item.accountingLines &&
                                            props.item.accountingLines[0] &&
                                            props.item.accountingLines[0].date
                                        "
                                        class="pl-6"
                                    >
                                        {{ formatDate(props.item.accountingLines[0].date) }}
                                    </h3>
                                    <h3 v-else class="pl-6">-</h3>
                                </td>

                                <!-- // ** wording -->
                                <td>
                                    <h3
                                        v-if="
                                            props.item.accountingLines &&
                                            props.item.accountingLines[0] &&
                                            props.item.accountingLines[0].wording
                                        "
                                        class="text-left"
                                    >
                                        {{ props.item.accountingLines[0].wording }}
                                    </h3>
                                    <h3 v-else class="text-left">-</h3>
                                </td>

                                <!-- // ** openDocument -->
                                <!-- <td class="text-center">
                                    <v-btn
                                        v-if="props.item.id"
                                        icon color="primary"
                                        @click="openDocument(props.item.id)"
                                    >
                                        <v-icon  size="small">remove_red_eye</v-icon>
                                    </v-btn>
                                </td> -->

                                <!-- // ** type -->
                                <td class="pl-3 text-center">
                                    {{ $t("document.shortType." + props.item.type || "UNKNOWN") }}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
import { cloneDeep } from "lodash";
import moment from "moment-timezone";

import UploadDocuments from "../document/UploadDocuments.vue";
import DocumentsTable from "../document/DocumentsTable.vue";
import Document from "../document/DocumentRouter.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        UploadDocuments,
        DocumentsTable,
        Document,
    },
})
export class AuditConnectedAcrResults extends Vue {
    @Prop({ default: null }) companyId: string;
    @Prop({ default: null }) results: Array<any>;

    // ** sort don't work properly : calculated on
    // ** "name", sometimes empty
    // ** "type" is different from $t("document.shortType." + props.item.type
    headers = [
        {
            title: "Date",
            value: "accountingLines[0].date",
            align: "start",
            class: "pl-8",
            sortable: true,
        },
        { title: "Libellé", value: "accountingLines[0].wording", align: "start", sortable: true },
        // { title: 'Voir', value: '', align: 'center', sortable: false },
        { title: "Type", value: "type", align: "center", sortable: true },
    ];

    // localConnectedResults: Array<any> = []

    dialogAuditCheckDocumentsManager: boolean = false;

    resultsExpand: boolean = false;

    openDocument(id) {
        if (id) {
            this.$router.push({
                name: "document",
                params: {
                    companyId: this.companyId,
                    id: id,
                },
            });
        }
    }

    formatDate(date) {
        return moment(date).format("DD-MM-YYYY");
    }

    statusTooltip(item) {
        const status = item.status;
        if (status === "INFORMATION_REQUEST") return item.chatStatus;
        return this.$t("document.status." + status);
    }

    statusColor(document) {
        const status = document.status;
        switch (status) {
            case "PENDING":
            case "DENIED":
            case "DELETED":
            case "ERROR":
                return "error";
            case "INFORMATION_REQUEST":
                return "primary";
            case "ORIGINAL_UPLOADED":
                return "orange";
            case "UPLOADED":
                return "orange";
            case "ANALYSED":
            case "ANALYSED_OK":
                return "primary";
            case "VALIDATED":
                return "secondary";
        }
        return "error";
    }
    // + END
}

export default toNative(AuditConnectedAcrResults);
</script>
